import React, { CSSProperties } from 'react';
import { Form, StrictFormProps } from 'semantic-ui-react';
import config from '@config/config';

import { styled } from '@modules/common/components/ThemeProvider/utils';

const PrimaryForm = (props: PrimaryFormProps) => {
  return <StyledPrimaryForm {...props} />;
};

export default PrimaryForm;

type PrimaryFormProps = {
  backgroundColor?: string;
  style?: CSSProperties;
} & StrictFormProps;

export const StyledPrimaryForm = styled(Form)<PrimaryFormProps>`
  background-color: ${props => props.backgroundColor ?? config.backgroundGrey};

  input {
    border-radius: 0 !important;
  }

  div.ui.selection.dropdown {
    border-radius: 0 !important;
    padding: 0.5rem 1rem !important;
    min-height: auto;
    & > input {
      padding: 0.5rem 1rem !important;
    }
    & > i.dropdown.icon {
      padding: 0.5rem 1rem !important;
    }
  }

  div.ui.active.upward.selection.dropdown {
    border-radius: 0 !important;
  }

  div.ui.input > input {
    padding: 0.5rem 1rem !important;
  }

  div.ui.input.icon > input {
    padding: 0.5rem 2.5rem !important;
  }

  .ui.toggle.checkbox input:checked ~ .box:before,
  .ui.toggle.checkbox input:checked ~ label:before {
    background-color: ${config.primaryColor} !important;
  }

  .ui.toggle.checkbox input ~ .box:before,
  .ui.toggle.checkbox input ~ label:before {
    background-color: grey !important;
  }
`;
